import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {setElementInnerHTML, createParagraphIn, createDivIn, createImgIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'
import {LobbyImage} from '@colonist/types'
import {UIAjaxWrapper} from '../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints'
import {AnalyticEventCategory, AnalyticEventType, RedeemFreeAvatarAnalytics} from '../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {CA} from '../../../shared/scripts/analytics/Analytics'

export class ViewPopupRedeemFreeAvatar extends ViewPopup {
    constructor() {
        const redeemButtonAction = async() => {
            await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiRedeemFreeAvatar(), undefined)

            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ReactivationAnalytics,
                category: AnalyticEventCategory.ABTestRedeemFreeAvatar,
                floatValue: RedeemFreeAvatarAnalytics.ABTestRedeemFreeAvatarButtonClicked,
            }
            void CA.sendAnalyticEvent(eventData)

            navigateToPage('/store#avatars')
        }

        super({key: 'strings:homePage.popups.redeemFreeAvatar.title'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            redeemButtonAction,
            () => undefined, true,
            {
                showXButton: false,
                showCheckButton: true,
                showXonHeader: false,
            })

        this.body.style.flexDirection = 'column'

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})
        createParagraphIn(this.body, {key: 'strings:homePage.popups.redeemFreeAvatar.body'}, 'popup-membership-body')

        const container = createDivIn(this.body, 'no-vertical-spacing', '')
        const imageWrapper = createDivIn(container, 'popup-subscription-in-room-items-wrapper', '')
        const imageCard = createDivIn(imageWrapper, 'popup-subscription-in-room-item-img', '')
        createImgIn(imageCard, LobbyImage.Avatars)
        imageWrapper.appendChild(imageCard)

        this.changeCheckButtonText({key: 'strings:homePage.popups.redeemFreeAvatar.button'})
        this.show()
    }
}
